import { Action } from "redux";

import { ILocalStorageKeyLoadedAction } from "@multiweb/reactCore/bridge/api";

/**
 * Zjistí, zda je akce akcí signalizující načtení hodnoty určitého klíče z local storage.
 * @param key Klíč v local storage.
 */
export const createIsLocalStorageKeyLoadedActionPattern = (key: string) => (action: Action) => (
    action instanceof ILocalStorageKeyLoadedAction && action.payload.key === key
);
